import React from 'react';
import { GlobeIcon, TargetIcon, TrendingUpIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function ServicesSection() {
  const services = [{
    icon: <GlobeIcon className="w-10 h-10 text-turquoise" data-id="element-212" />,
    title: 'Arquitectura de Conversión Médica',
    description: 'Websites clínicos diseñados para que el paciente agende, no solo para informar. Cada elemento está estructurado bajo principios de confianza y experiencia de usuario para convertir visitantes en citas reales.'
  }, {
    icon: <TargetIcon className="w-10 h-10 text-turquoise" data-id="element-213" />,
    title: 'Dominio de Google Local',
    description: 'Posicionamos su consultorio en el Top 3 de Google Maps en su zona. Optimización de perfil profesional, reseñas y SEO local para que sea la primera opción cuando un paciente busca su especialidad.'
  }, {
    icon: <TrendingUpIcon className="w-10 h-10 text-turquoise" data-id="element-214" />,
    title: 'Sistemas de Captación AHA',
    description: 'Filtre pacientes por WhatsApp y automatice su agenda para recibir solo citas calificadas. Eliminamos las consultas que no avanzan y protegemos su tiempo clínico con flujos inteligentes de captación.'
  }];
  return <section id="servicios" className="py-24 bg-petrol relative" data-id="element-215">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-216">
        <FadeIn className="mb-20" data-id="element-217">
          <div className="flex items-center gap-4 mb-4" data-id="element-218">
            <div className="h-[1px] w-12 bg-turquoise" data-id="element-219"></div>
            <span className="text-turquoise uppercase tracking-widest text-sm font-semibold" data-id="element-220">
              Nuestra Expertise
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold" data-id="element-221">
            Servicios de Alto Impacto
          </h2>
        </FadeIn>

        <div className="space-y-12" data-id="element-222">
          {services.map((service, index) => <FadeIn key={index} delay={index * 0.1} direction={index % 2 === 0 ? 'left' : 'right'} className="flex flex-col md:flex-row gap-8 items-start md:items-center bg-petrol-light p-8 md:p-12 rounded-2xl border border-petrol-lighter hover:border-turquoise/20 transition-colors relative overflow-hidden group" data-id="element-223">
              {/* Subtle tech accent on hover */}
              <div className="absolute top-0 left-0 w-1 h-full bg-turquoise opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-224"></div>

              <div className="flex-shrink-0 w-20 h-20 rounded-2xl bg-petrol flex items-center justify-center border border-petrol-lighter shadow-inner group-hover:border-turquoise/30 transition-colors" data-id="element-225">
                {service.icon}
              </div>
              <div className="flex-grow" data-id="element-226">
                <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-227">
                  {service.title}
                </h3>
                <p className="text-silver text-lg leading-relaxed max-w-3xl" data-id="element-228">
                  {service.description}
                </p>
              </div>
              <div className="hidden md:block w-px h-24 bg-gradient-to-b from-transparent via-petrol-lighter to-transparent mx-8" data-id="element-229"></div>
              <div className="flex-shrink-0" data-id="element-230">
                <a href="https://wa.me/50672642898" target="_blank" rel="noopener noreferrer" className="text-turquoise hover:text-white font-medium flex items-center gap-2 transition-colors group/link" data-id="element-231">
                  Consultar
                  <span className="group-hover/link:translate-x-1 transition-transform" data-id="element-232">
                    →
                  </span>
                </a>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}